/*
 * La configuration Firebase de l'application, côté navigateur.
 *
 * CE FICHIER EST IGNORÉ PAR GIT (voir .gitignore), et c'est pour cela qu'il
 * avait disparu : le retour sur `master` n'a pas pu le restaurer, puisqu'il
 * n'est dans aucun commit. Sans lui, `src/plugins/firebase.js` ne résout plus
 * son import et RIEN NE SE CONSTRUIT.
 *
 * LES VALEURS SONT CELLES DE LA PRODUCTION (`tcg-21`), reprises de `.env.prod`
 * — qui dit lui-même d'où elles viennent : « Ignoré par git, comme l'était
 * src/config/firebase.js dont ces valeurs proviennent. » C'est donc exactement
 * ce que ce fichier contenait avant que la branche v2 ne déplace la
 * configuration dans des fichiers d'environnement.
 *
 * POUR TRAVAILLER SUR LA BÊTA (`tcg-21-beta`), remplacer par les valeurs de
 * `.env.dev` — MAIS la clé App Check codée en dur dans `src/plugins/firebase.js`
 * (`6Lc4Dl8s…`, reCAPTCHA v3) est enregistrée pour `tcg-21` : pointer la
 * configuration sur la bêta sans changer aussi cette clé donne un
 * « App attestation failed » sur le moindre appel, et rien d'autre.
 *
 * Rien ici n'est secret : cette configuration part dans le paquet servi au
 * navigateur. Ce qui protège le projet, ce sont les règles Firestore et
 * App Check.
 */
export default {
  apiKey: "AIzaSyDY7oZDOjmzFkbpgTlNckuBkdMzYWOGuic",
  authDomain: "tcg-21.firebaseapp.com",
  projectId: "tcg-21",
  storageBucket: "tcg-21.firebasestorage.app",
  messagingSenderId: "227355970348",
  appId: "1:227355970348:web:250bb27a27bf94c0ba7a89",
}
